import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPromotionmagblack = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m.503 0 5.997.003c.133 0 .26.052.353.146l9.001 9a.5.5 0 0 1 0 .707l-5.998 5.997a.5.5 0 0 1 -.707 0l-9.003-8.999a.498.498 0 0 1 -.146-.353l.003-6.002a.5.5 0 0 1 .5-.499zm10.33 7.168a.57.57 0 0 0 -.809 0l-2.856 2.856-.067.08a.57.57 0 0 0 .875.728l2.856-2.856.067-.08a.57.57 0 0 0 -.067-.728zm-2-2a.57.57 0 0 0 -.809 0l-2.856 2.856-.067.08a.57.57 0 0 0 .875.728l2.856-2.856.067-.08a.57.57 0 0 0 -.067-.728zm-4.123-1.885c-.37-.372-1.04-.382-1.42 0a1.023 1.023 0 0 0 0 1.426 1 1 0 0 0 1.42-.01 1.01 1.01 0 0 0 0-1.416z",
		fill: "#2b2b2b"
	})
});
export default SvgPromotionmagblack;
